<style lang="scss" type="stylesheet/scss" scoped>
@import "@/assets/var.scss";
.seller-home {
  padding: 35px 25px 13px;
}

.tabs {
  .tab {
    font-size: 14px;
    color: #666;
    margin: 0 10px;
    display: inline-block;
    font-weight: normal;
    padding: 40px 20px 22px;
    position: relative;
    cursor: pointer;
    &:first-child {
      margin-left: 0;
    }
    &:hover {
      color: $mainBlue;
    }
    &.active {
      color: $mainBlue;
      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 20px;
        right: 20px;
        height: 4px;
        background: $mainBlue;
      }
    }
  }
}

.offer-body {
  padding: 25px;
}

/deep/ .offer-table th {
  background: #f8f8f8;
  color: #333;
  font-weight: bold !important;
}
</style>

<template>
  <page-wrapper title="采购管理"
                padding="30px 25px 0">
    <template slot="header">
      <div class="tabs">
        <div class="tab"
             :class="{ active : activeIndex === index }"
             @click="activeIndex = index"
             v-for="(item,index) in ['全部信息','比价中','已中标','未中标']">{{item}}</div>
      </div>
    </template>
    <div class="offer-body">
      <el-table :data="offerList"
                class="offer-table">
        <el-table-column label="报价项目"
                         prop="name"></el-table-column>
        <el-table-column label="报价时间"
                         prop="time"></el-table-column>
        <el-table-column label="报价截止时间"
                         prop="deadLine"></el-table-column>
        <el-table-column label="状态"
                         width="100"
                         prop="status"></el-table-column>
        <el-table-column label="操作"
                         prop="status">
          <template slot-scope='scope'>
            <el-button @click="$router.push(`/seller/offer-detail?id=123`)"
                       type="text">查看</el-button>
            <el-button type="text">联系卖家</el-button>
            <el-button type="text">取消订单</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination background
                     style="text-align:center;margin-top:22px"
                     layout="prev, pager, next"
                     :total="0">
      </el-pagination>
    </div>
  </page-wrapper>
</template>

<script type="text/ecmascript-6">
export default {
  name: "seller-home-offer",
  data() {
    return {
      activeIndex: 0,
      offerList: [
        {
          name: "常规采购：实单求购蒸压灰加气混凝土块",
          time: "2020-02-02 10:10:10",
          deadLine: "2020-02-02 10:10:10",
          status: "已中标",
        },
        {
          name: "常规采购：实单求购蒸压灰加气混凝土块",
          time: "2020-02-02 10:10:10",
          deadLine: "2020-02-02 10:10:10",
          status: "已中标",
        },
        {
          name: "常规采购：实单求购蒸压灰加气混凝土块",
          time: "2020-02-02 10:10:10",
          deadLine: "2020-02-02 10:10:10",
          status: "已中标",
        },
        {
          name: "常规采购：实单求购蒸压灰加气混凝土块",
          time: "2020-02-02 10:10:10",
          deadLine: "2020-02-02 10:10:10",
          status: "已中标",
        },
      ],
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        publishStatus: "",
      },
    };
  },
  created() {
    this.getTableData();
    this.offerList = [];
  },
  methods: {
    async getTableData() {
      let res = await this.$axios.post({
        url: "/v1/sellerCenter/purchaseList/getSCPurchaseListOfferList",
        data: this.queryForm,
      });
    },
  },
};
</script>
